import React, { useEffect } from 'react';
import { Box, Tabs, TabList, TabPanels, Tab, TabPanel, Heading } from '@chakra-ui/react';
import { useAppDispatch, useAppSelector } from '../../../utils/reduxHooks';
import { getCatalogAction, setCarTypeAction } from '../../../modules/catalog/actions';
import { selectSelectedCarType } from '../../../modules/catalog/selectors';
import { MarksGrid } from '../../components/catalogPage/marksGrid';
import { BrandsGrid } from '../../components/catalogPage/brandsGrid';
import { useNavigate } from 'react-router-dom';
import { routes } from '../../../constants/routes';

export const CarsTypesList: React.FC = () => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const carType = useAppSelector(selectSelectedCarType);

  // useEffect(() => {
  //   dispatch(getCatalogAction.request());
  // }, []);

  const handleClickTab = () => {
    navigate(routes.MAIN);
    dispatch(setCarTypeAction(''));
  };

  return (
    <Box p={4}>
      <Tabs>
        <Heading mb="32px">Каталог запчастей</Heading>
        <TabList>
          <Tab pl={0} onClick={handleClickTab}>
            Типы автомобилей
          </Tab>
          <Tab pl={0} onClick={handleClickTab}>
            Все марки
          </Tab>
        </TabList>
        <TabPanels>
          <TabPanel>{carType ? <MarksGrid /> : <BrandsGrid />}</TabPanel>
          <TabPanel>
            <MarksGrid />
          </TabPanel>
        </TabPanels>
      </Tabs>
    </Box>
  );
};
